// const host = "https://api.veim.cn";
var host = 'https://api.veim.cn:7000';

var ApiRouter = {
  getCommunityDetail: host + '/api/v1/blog/',
  //博客评论列表
  blogCommentList: host + '/api/v1/blog/comments',
}

export default ApiRouter



// WEBPACK FOOTER //
// ./src/network/ApiRouter.js